import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgendamentosService } from 'src/app/services/agendamentos.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';

const MY_FORMATS = {
  display: {
    dateInput: 'DD/MM/YYYY'
  }
}

@Component({
  selector: 'app-minha-agenda-client',
  templateUrl: './minha-agenda-client.component.html',
  styleUrls: ['./minha-agenda-client.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class MinhaAgendaClientComponent implements OnInit {

  @ViewChild('paciente') pacienteFiltro: ElementRef<HTMLInputElement>
  @ViewChild('agenda') agendaFiltro: ElementRef<HTMLInputElement>
  @ViewChild('dateStart') dataInicioFiltro: ElementRef<HTMLInputElement>
  @ViewChild('dateEnd') dataFinalFiltro: ElementRef<HTMLInputElement>
  @ViewChild('especialidade') especialidadeFiltro: ElementRef<HTMLInputElement>

  ordenacao: 'dataAsc' | 'dataDesc' | 'pacAsc' | 'pacDesc' = 'dataDesc'
  displayedColumns: string[];
  dataSource: any[];
  dataStore: any[];
  isAdmin: boolean = false;
  filtro: string = 'pendentes';
  userData: any = {};
  smallScreen: boolean;

  constructor(
    private router: Router,
    private agendamentosService: AgendamentosService,
    private breakpointObserver: BreakpointObserver,
    private serverUrlService: ServerUrlService
  ) {

    this.smallScreen = (window.innerWidth <= 400) ? true : false;
      breakpointObserver.observe([
        Breakpoints.XSmall,
        Breakpoints.Small
      ]).subscribe(result => {
        this.smallScreen = result.matches;
      });

  }

  ngOnInit() {
    this.userData = sessionStorage.getItem('userData');
    if (!this.userData) {
      window.location.href = '/';
    }
    
    const usuario = JSON.parse(this.userData)
    if(usuario.ocultar_historico) {
      window.location.href = '/' + this.serverUrlService.getName();
    }

    const { tipo, token, id } = usuario;
    
    if (tipo === 'paciente') {
      this.displayedColumns = ['data', 'hora', 'agenda', 'especialidade',
        'procedimento', 'convenio', 'status']; // , 'cancelar'

      this.agendamentosService.buscaMeusAgendamentos(id, token)
        .subscribe(
          (response: any) => {
            this.dataStore = response.body;
            this.onClickFiltrar();
            const { mandarParaAgendamento, agendamentoId, agendaTipo } = history.state
            if (mandarParaAgendamento) {
              const found = this.dataStore.find((val) => (
                val.integracao_id === agendamentoId && val.tipo === agendaTipo
              ))

              if (found) {
                this.editarAgendamento(found, true)
              }
            }
          },
          (err) => console.error(err)
        );

    } else {
      this.isAdmin = true;
      this.displayedColumns = ['data', 'hora', 'nome', 'agenda', 'especialidade',
        'procedimento', 'convenio', 'status'];

      this.agendamentosService.buscaTodosAgendamentos(token)
        .subscribe(
          (response: any) => {
            this.dataStore = response.body;
            this.onClickFiltrar();
            const { mandarParaAgendamento, agendamentoId, agendaTipo } = history.state
            if (mandarParaAgendamento) {
              const found = this.dataStore.find((val) => (
                val.integracao_id === agendamentoId && val.tipo === agendaTipo
              ))

              if (found) {
                this.editarAgendamento(found)
              }
            }
          },
          (err) => console.error(err)
      );
    }
  }

  onClickOrdenar() {
    if (this.ordenacao === 'dataAsc') {
      this.dataSource.sort((a,b) => {
        const aDate = new Date(a.data).getTime()
        const bDate = new Date(b.data).getTime()
        return bDate - aDate
      })
      this.dataSource.reverse()
    }
    if (this.ordenacao === 'dataDesc') {
      this.dataSource.sort((a,b) => {
        const aDate = new Date(a.data).getTime()
        const bDate = new Date(b.data).getTime()
        return bDate - aDate
      })
    }
    if (this.ordenacao === 'pacAsc') {
      this.dataSource.sort((a, b) => {
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1
        return 0
      })
    }
    if (this.ordenacao === 'pacDesc') {
      this.dataSource.sort((a, b) => {
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) return -1
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) return 1
        return 0
      })
      this.dataSource.reverse()
    }
  }

  converteData(datastr: string) {
    const dataparts = datastr.split('/')
    return new Date(
      parseInt(dataparts[2]),
      parseInt(dataparts[1]) - 1,
      parseInt(dataparts[0]) - 1
    )
  }

  onClickFiltrar() {
    if (this.filtro === 'todos') {
      this.dataSource = this.dataStore;
    } else {
      this.dataSource = this.dataStore.filter(item => item.status === 'pendente');
    }

    this.onClickOrdenar()
    
    if (this.pacienteFiltro.nativeElement.value)
      this.dataSource = this.dataSource.filter(
        item => item.nome
                  .toLowerCase()
                  .startsWith(this.pacienteFiltro.nativeElement.value.toLowerCase())
      )
    if (this.agendaFiltro.nativeElement.value)
      this.dataSource = this.dataSource.filter(
        item => item.agenda_nome
                  .toLowerCase()
                  .startsWith(this.agendaFiltro.nativeElement.value.toLowerCase())
      )
    if (this.especialidadeFiltro.nativeElement.value)
      this.dataSource = this.dataSource.filter(
        item => item.especialidade_nome
                  .toLowerCase()
                  .startsWith(this.especialidadeFiltro.nativeElement.value.toLowerCase())
      )
    if (this.dataInicioFiltro.nativeElement.value)
      this.dataSource = this.dataSource.filter(
        item => 
          new Date(item.data.slice(0, 10)).getTime() >= +this.converteData(this.dataInicioFiltro.nativeElement.value).getTime()
      )
    if (this.dataFinalFiltro.nativeElement.value)
      this.dataSource = this.dataSource.filter(
        item => 
          new Date(item.data.slice(0, 10)).getTime() <= +this.converteData(this.dataFinalFiltro.nativeElement.value).getTime()
      )
  }

  onCancelarClick(element) {
    this.router.navigate(['/' + this.serverUrlService.getName() +`/client/cancela/${element.id}`]);
  }

  parseData(data) {
    if (!data) { return ''; }
    const dataSplit = data.slice(0, 10).split('-');
    return `${dataSplit[2]}/${dataSplit[1]}/${dataSplit[0]}`;
  }

  editarAgendamento(element: any, paraPreparo?: boolean) {
    //if (this.isAdmin) {
    if (!paraPreparo) {
      this.router.navigateByUrl('/' + this.serverUrlService.getName() +`/admin/editar-agendamento/${element.id}/${element.usuario_id}`);
    } else {
      this.router.navigateByUrl('/' + this.serverUrlService.getName() +`/admin/editar-agendamento/${element.id}/${element.usuario_id}`);
    }
    //}
  }

  editarAgendamentoPac(element: any) {
    if (this.isAdmin == false) {
      window.open(element.linkPagamento,'_system');
    }
  }

  primeiraLetraMaiuscula(myString: string) {
    return myString.charAt(0).toUpperCase() + myString.slice(1);
  }

  getTextColor(status: string): string {
    const normalizedStatus = status.toLowerCase()
    switch (normalizedStatus){
      case 'agendado':
        return '#32C192';
      case 'pendente':
        return '#647899';
      case 'desmarcado':
        return '#F66056';
      default:
        return '#889CBF';
    }
  }
}
